import React from 'react';
import Logo from '@/components/Logo';

interface OnboardingTemplateProps {
  children: React.ReactNode;
  showStepper?: boolean;
  stepperContent?: React.ReactNode;
}

const OnboardingTemplate: React.FC<OnboardingTemplateProps> = ({
  children,
  showStepper = false,
  stepperContent,
}) => (
  <div className="min-h-screen px-4 md:px-0 pt-24 md:pt-0 flex flex-col gap-8 md:gap-0  bg-white relative md:flex-row md:items-center md:justify-center">
    {/* Logo (mobile: centered above card, desktop: absolute top right) */}
    <div className="flex justify-center mt-8 mb-4 md:hidden">
      <Logo />
    </div>
    <div className="hidden md:block absolute top-8 right-16 z-10">
      <Logo />
    </div>
    {/* Main content */}
    <div className="flex md:flex-1 items-center justify-center w-full">
      {/* Card */}
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg px-4 py-6 flex flex-col justify-center md:w-[520px] md:p-12 md:mr-12 md:mt-0 md:mb-0">
        {/* Stepper/Progress (optional, always inside card) */}
        {showStepper && stepperContent}
        {children}
      </div>
      {/* Illustration (desktop only) */}
      <div className="hidden md:flex items-center">
        <img
          src="/onboarding_illustration.png"
          alt="Onboarding Illustration"
          className="w-[600px] h-[600px] object-cover"
          draggable={false}
        />
      </div>
    </div>
  </div>
);

export default OnboardingTemplate; 